module.exports = __webpack_public_path__ + "static/media/logo_verme_color.66c95870.svg";